export default __webpack_public_path__ + "static/media/sentiment-positive.9a5b85ae.svg";